import { render, staticRenderFns } from "./MessagesTable.vue?vue&type=template&id=b6505c3e&scoped=true&"
import script from "./MessagesTable.vue?vue&type=script&lang=js&"
export * from "./MessagesTable.vue?vue&type=script&lang=js&"
import style0 from "./MessagesTable.vue?vue&type=style&index=0&id=b6505c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6505c3e",
  null
  
)

export default component.exports